/**
 * Data Center Prep Research — Theme Toggle
 * Default: light mode, regardless of OS preference.
 * Dark mode is opt-in only — activated by explicit user toggle.
 * Persists choice in localStorage. Sets data-theme on <html>.
 * No dependencies.
 */
(function () {
  var html = document.documentElement;
  var STORAGE_KEY = 'dcpr-theme';

  function getStored() {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
    // Default: always light, regardless of OS preference
    return 'light';
  }

  function applyTheme(theme) {
    html.setAttribute('data-theme', theme);
  }

  function updateFooterLabel(theme) {
    var btn = document.getElementById('footer-theme-toggle');
    if (!btn) return;
    btn.textContent = theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode';
  }

  // Apply immediately to avoid flash
  applyTheme(getStored());

  document.addEventListener('DOMContentLoaded', function () {
    // Initialize footer label
    var currentTheme = html.getAttribute('data-theme') || 'light';
    updateFooterLabel(currentTheme);

    var btn = document.getElementById('footer-theme-toggle');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var current = html.getAttribute('data-theme') || 'light';
      var next = current === 'dark' ? 'light' : 'dark';
      applyTheme(next);
      localStorage.setItem(STORAGE_KEY, next);
      updateFooterLabel(next);
    });
  });
})();
